import { Component } from '@angular/core';
import { AuthService } from './services/identity/auth.service';
import { UserService } from './services/identity/user.service';
import { NgxLoadingBar } from '@ngx-loading-bar/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  /**
   * Static property that defines if loading
   * bar is toggled on or off.
   */
  public static includeLoadingBar: boolean = true;

  /**
   * Static property that defines loading bar reference.
   */
  public static barRef: string = 'http';

  /**
   * Getter of includeLoadingBar static property
   * to make it available inside templates.
   */
  get includeLoadingBar(): boolean {
    return AppComponent.includeLoadingBar;
  }

  /**
   * Getter of barRef static property
   * to make it available inside templates.
   */
  get barRef(): string {
    return AppComponent.barRef;
  }

  constructor() {}
}
